export default "__VITE_ASSET__DG_LvE7m__"